$(document).ready(function() {
  // Trigger poster click to initiate video loading
  $(window).on('scroll', function () {
      // Check if the user has scrolled down at least 300px
      if ($(window).scrollTop() >= 650) {
          $('.video-section__poster').click();
          const interval = setInterval(() => {
              const $videoTag = $('deferred-media video');
              if ($videoTag.length > 0) {
                  clearInterval(interval);
                  $videoTag.each(function () {
                      const video = this;
                      video.muted = true;
                      video.play();
                  });
              }
          }, 500);
      }
  });


  $(window).on('scroll', function () {
      // Check if the user has scrolled down at least 300px
      if ($(window).scrollTop() >= 900) {
        // alert();
          $('.video-block').click();
          const interval = setInterval(() => {
              const $videoTag = $('.vd-swiper-container video');
              if ($videoTag.length > 0) {
                  clearInterval(interval);
                  $videoTag.each(function () {
                      const video = this;
                      video.muted = true;
                      video.play();
                  });
              }
          }, 500);
      }
  });
  document.querySelectorAll('.vdt_btn_video').forEach(function(wrapper) {
    wrapper.addEventListener('click', function() {
      const video = wrapper.querySelector('video');
      const hideElement = wrapper.querySelector('.vdt_hide');
      const iconElement = wrapper.querySelector('.vdt_icon-play');
      if (video.paused) {
        video.play();
        iconElement.classList.add('vdt_hide');
      } else {
        video.pause();
        hideElement.classList.remove('vdt_hide');
      }
    });
  });

  // Hotspot slider
    new Swiper('[data-hotspotslider="true"]', {
        loop: true,
        nextButton: '.ht-swiper-button-next',
        prevButton: '.ht-swiper-button-prev',
        slidesPerView: 2,
        paginationClickable: true,
        spaceBetween: 20,
        breakpoints: {
            1920: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            1028: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            480: {
                slidesPerView: 1,
                spaceBetween: 10
            }
        }
    });




  
  //  vst
    new Swiper('.vd-swiper-container', {
        loop: true,
        nextButton: '.vdt-swiper-button-next',
        prevButton: '.vdt-swiper-button-prev',
        slidesPerView: 6,
        paginationClickable: true,
        spaceBetween: 10,
        breakpoints: {
            1920: {
                slidesPerView: 6,
                spaceBetween: 10
            },
            1028: {
                slidesPerView: 4,
                spaceBetween: 10
            },
            800: {
                slidesPerView: 3,
                spaceBetween: 10
            },
            480: {
                slidesPerView: 2,
                spaceBetween: 10
            }
        }
    });


  
  // collection slider
    var swiper = new Swiper (".slide-content", {
        loop: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 4,
        paginationClickable: true,
        spaceBetween: 20,
        breakpoints: {
            1920: {
                slidesPerView: 4,
                spaceBetween: 30
            },
            1028: {
                slidesPerView: 4,
                spaceBetween: 30
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            680: {
                slidesPerView: 1,
                spaceBetween: 10
            }
        }
    });

  
 

});